import { useCallback } from 'react';
import { useLogMarketAnalyticsEvent } from '../../../hooks/useLogMarketAnalyticsEvent';

export const useLogClickBanner = () => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();

  return useCallback(
    (params: { index: number; bannerSno: number; goodsSno: number | null }) => {
      logMarketAnalytics({
        name: 'CLICK_BANNER',
        analytics: {
          BANNER_INDEX: params.index,
          BANNER_SNO: params.bannerSno.toString(),
          GOODS_SNO: params.goodsSno?.toString() ?? null,
        },
      });
    },
    [logMarketAnalytics],
  );
};
